export { default } from "./ViewPageContent";
